export const isInfoMetric = (metric: string) => metric.endsWith('_info');
